import { Funcionalidade } from '../comum/modelos/funcionalidade';
import { GrupoAcesso } from '../comum/modelos/grupo-acesso';
import { UsuarioGrupoAcesso } from '../comum/modelos/usuario-grupo-acesso';
import { Injectable } from '@angular/core';
import { SettingsService } from '../settings.service';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { GrupoAcessoPermissaoFuncionalidade } from '../comum/modelos/grupo-acesso-permissao-funcionalidade';
import { RoleUsuario } from '../comum/modelos/role-usuario';
import { UsuarioFuncionalidade } from '../comum/modelos/usuario-funcionalidade';
import { UsuarioArea } from '../comum/modelos/usuario-area';

@Injectable()
export class PermissoesAcessoService {

  private _host: string;

  constructor(
    private _settingsService: SettingsService,
    private _http: HttpClient) {
    this._host = this._settingsService.obterHostBase() + '/permissoes-acesso/';
  }

  obterFuncionalidadesHttp(): Observable<Funcionalidade[]> {
    return this._http.get(this._host + 'funcionalidade/')
      .catch(this.handleError);
  }

  obterFuncionalidadeHttp(id: number): Observable<Funcionalidade> {
    return this._http.get(this._host + 'funcionalidade/' + id)
      .catch(this.handleError);
  }

  cadastrarFuncionalidadeHttp(funcionalidade: Funcionalidade): Observable<HttpResponse<Funcionalidade>> {
    return this._http
      .post(this._host + 'funcionalidade/', funcionalidade, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  atualizarFuncionalidadeHttp(funcionalidade: Funcionalidade): Observable<HttpResponse<Funcionalidade>> {
    return this._http
      .put(this._host + 'funcionalidade/', funcionalidade, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  apagarFuncionalidadeHttp(id: number): Observable<HttpResponse<Funcionalidade>> {
    return this._http
      .delete(this._host + 'funcionalidade/' + id)
      .catch(this.handleError);
  }

  obterGruposAcessoHttp(id: number): Observable<GrupoAcesso[]> {
    return this._http.get(this._host + 'grupo-acesso/cliente/' + id)
      .catch(this.handleError);
  }

  obterGrupoAcessoHttp(id: number): Observable<GrupoAcesso> {
    return this._http.get(this._host + 'grupo-acesso/' + id)
      .catch(this.handleError);
  }

  cadastrarGrupoAcessoHttp(grupoAcesso: GrupoAcesso): Observable<HttpResponse<GrupoAcesso>> {
    return this._http
      .post(this._host + 'grupo-acesso/', grupoAcesso, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  atualizarGrupoAcessoHttp(grupoAcesso: GrupoAcesso): Observable<HttpResponse<GrupoAcesso>> {
    return this._http
      .put(this._host + 'grupo-acesso/', grupoAcesso, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  apagarGrupoAcessoHttp(id: number): Observable<HttpResponse<GrupoAcesso>> {
    return this._http
      .delete(this._host + 'grupo-acesso/' + id)
      .catch(this.handleError);
  }

  obterGruposAcessoUsuarioHttp(id: number): Observable<UsuarioGrupoAcesso[]> {
    return this._http.get(this._host + 'grupo-acesso-usuario/' + id)
      .catch(this.handleError);
  }

  cadastrarGrupoAcessoUsuarioHttp(grupoAcessoUsuario: UsuarioGrupoAcesso):
    Observable<HttpResponse<UsuarioGrupoAcesso>> {
    return this._http
      .post(this._host + 'grupo-acesso-usuario/', grupoAcessoUsuario, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  cadastrarGruposAcessoUsuarioHttp(gruposAcessoUsuario: UsuarioGrupoAcesso[]):
    Observable<HttpResponse<UsuarioGrupoAcesso[]>> {
    return this._http
      .post(this._host + 'grupo-acesso-usuario/', gruposAcessoUsuario, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  apagarGrupoAcessoUsuarioHttp(id: number): Observable<HttpResponse<UsuarioGrupoAcesso>> {
    return this._http
      .delete(this._host + 'grupo-acesso-usuario/' + id)
      .catch(this.handleError);
  }

  apagarGruposAcessoUsuarioHttp(gruposAcessoUsuario: UsuarioGrupoAcesso[]):
    Observable<HttpResponse<UsuarioGrupoAcesso[]>> {
    return this._http
      .patch(this._host + 'grupo-acesso-usuario/', gruposAcessoUsuario, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  obterGruposAcessoPermissaoFuncionalidadeHttp(id: number): Observable<GrupoAcessoPermissaoFuncionalidade[]> {
    return this._http.get(this._host + 'grupo-acesso-permissao-funcionalidade/' + id)
      .catch(this.handleError);
  }

  cadastrarGruposAcessoPermissaoFuncionalidadeHttp(gruposAcessoPermissao: GrupoAcessoPermissaoFuncionalidade[]):
    Observable<HttpResponse<GrupoAcessoPermissaoFuncionalidade[]>> {
    return this._http
      .post(this._host + 'grupo-acesso-permissao-funcionalidade/', gruposAcessoPermissao, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  atualizarGruposAcessoPermissaoFuncionalidadeHttp(gruposAcessoPermissao: GrupoAcessoPermissaoFuncionalidade[]):
    Observable<HttpResponse<GrupoAcessoPermissaoFuncionalidade[]>> {
    return this._http
      .put(this._host + 'grupo-acesso-permissao-funcionalidade/', gruposAcessoPermissao, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  obterRolesUsuario(id: number): Observable<RoleUsuario[]> {
    return this._http.get(this._host + 'roles-usuario/' + id)
      .catch(this.handleError);
  }

  obterUsuariosFuncionalidadeHttp(idFuncionalidade: number, idGrupoAcesso: number): Observable<UsuarioFuncionalidade[]> {
    return this._http.get(this._host + 'usuario-funcionalidade?idFuncionalidade=' + idFuncionalidade
      + '&idGrupoAcesso=' + idGrupoAcesso)
      .catch(this.handleError);
  }

  cadastrarUsuariosFuncionalidadeHttp(usuariosFuncionalidade: UsuarioFuncionalidade[]): Observable<HttpResponse<UsuarioFuncionalidade[]>> {
    return this._http
      .post(this._host + 'usuario-funcionalidade/', usuariosFuncionalidade, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  removerUsuariosFuncionalidadeHttp(usuariosFuncionalidade: UsuarioFuncionalidade[]): Observable<HttpResponse<UsuarioFuncionalidade[]>> {
    return this._http
      .patch(this._host + 'usuario-funcionalidade/', usuariosFuncionalidade, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  obterAreasUsuario(id: number): Observable<UsuarioArea[]> {
    return this._http.get(this._host + 'area-usuario/' + id)
      .catch(this.handleError);
  }

  cadastrarUsuariosAreaHttp(usuariosArea: UsuarioArea[]): Observable<HttpResponse<UsuarioArea[]>> {
    return this._http
      .post(this._host + 'area-usuario/', usuariosArea, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  removerUsuariosAreaHttp(usuariosArea: UsuarioArea[]): Observable<HttpResponse<UsuarioArea[]>> {
    return this._http
      .patch(this._host + 'area-usuario/', usuariosArea, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  private handleError(error: Response) {

    console.error(error);

    return Observable.throw(error.json().error || 'Server error');

  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/permissoes-acesso/permissoes-acesso.service.ts